import moment from "moment";
import { urls } from "../constants/app";
import { resetError, setError } from "./errors";
import request from "./utils/request";

export function fetchWriteoffs(dataParams = {}) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'writeoffs', value: true });
        const paging = getState().writeoffs.paging;
        const sorting = getState().writeoffs.sorting;
        const filters = getState().writeoffs.filters;
        const user = getState().user.info;
        
        if(!filters.endDate) filters.endDate = moment().endOf('day').toDate();
        if(!filters.startDate) filters.startDate = moment().startOf('day').toDate();

        const params = { ...dataParams };

        if (filters.id) {
            dataParams['id'] = filters.id;
            params['id'] = filters.id;
        }

        if (filters.points && filters.points.length > 0) {
            const pointIds = filters.points.map((point) => point.value).filter((item) => item);
            dataParams['point.id_in'] = pointIds;
            params['point.id_in'] = pointIds;
        } else if (filters.point) {
            dataParams['point'] = filters.point;
            params['point'] = filters.point;
        } else {
            if(user.points.length > 0 || filters.points.length > 0) {
                const pointIds = user.points.map(item => item.id);    
                dataParams['point.id_in'] = pointIds;
                params['point.id_in'] = pointIds;
            }
        }

        if (filters.writeoffreason) {
            dataParams['writeoffreason'] = filters.writeoffreason;
            params['writeoffreason'] = filters.writeoffreason;
        }

        if (filters.startDate) {
            const date = moment(filters.startDate).startOf('day').toDate();
            dataParams['date_gte'] = date;
            params['date_gte'] = date;
        }

        if (filters.endDate) {
            const date = moment(filters.endDate).endOf('day').toDate();
            dataParams['date_lte'] = date;
            params['date_lte'] = date;
        }

        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
        params['_sort'] = `${sorting.field}:${sorting.type}`;

        request({ method: 'get', url: urls.writeoffs+'/count', params: dataParams })
            .then(result => {
                dispatch({ type: 'SET_WRITEOFFS_COUNT', count: result });
                return;
            })
            .then(async () => {
                return request({ method: 'get', url: urls.writeoffs, params }).then(async (response) => {
                    dispatch({ type: 'SET_WRITEOFFS', list: response });
                    dispatch({ type: 'SET_LOADER', field: 'writeoffs', value: false });
                })
            })
            .catch(error => {
                dispatch(setError(error, 'writeoffs'));
                dispatch({ type: 'SET_LOADER', field: 'writeoffs', value: false });
            });
    }
}

export function deleteWriteoff(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'writeoffs', value: true });
    dispatch(resetError('writeoffs'));
    return request({ method: 'delete', url:`${urls.writeoffs}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'writeoffs', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 507 }, 'writeoffs'));
            dispatch({ type: 'SET_LOADER', field: 'writeoffs', value: false });
            return false;
        });
    }
}

export function setWriteoffsFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_WRITEOFFS_FILTERS', filters });
    }
}

export function updateWriteoff(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'writeoff', value: true });
    dispatch(resetError('writeoffs'));

        return request({ method: 'put', url: `${urls.writeoffs}/${id}`, data })
            .then((response) => {
                dispatch({ type: 'SET_WRITEOFF', detail: response });
                dispatch({ type: 'SET_LOADER', field: 'writeoff', value: false });
                return response.id;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'writeoffs'));
                dispatch({ type: 'SET_LOADER', field: 'writeoff', value: false });
                return false;
            });
    
    }
}

export function fetchWriteoff(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'writeoff', value: true });

    return request({ method: 'get', url: `${urls.writeoffs}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_WRITEOFF', detail: response });
            dispatch({ type: 'SET_LOADER', field: 'writeoff', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'writeoff'));
            dispatch({ type: 'SET_LOADER', field: 'writeoff', value: false });
            return null
        });
    }
}

export function setWriteoffsPaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_WRITEOFFS_PAGING', paging });
    }
}

export function createWriteoff(data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'writeoff', value: true });
    dispatch(resetError('writeoffs'));

        return request({ method: 'post', url: `${urls.writeoffs}`, data })
            .then((response) => {
                dispatch({ type: 'SET_WRITEOFF', detail: response });
                dispatch({ type: 'SET_LOADER', field: 'writeoff', value: false });
                return response.id;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'writeoffs'));
                dispatch({ type: 'SET_LOADER', field: 'writeoff', value: false });
                return false;
            });
    
    }
}